import React from 'react'

const InformacaoAgendamentoIcon = () => {
  return (
    <svg
      className="primary-fill-color"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="32"
      height="33"
      viewBox="0 0 32 33"
    >
      <defs>
        <path
          id="nsresuntxa"
          d="M9.067 0c.766 0 1.392.606 1.392 1.376v2.436c0 .179.154.344.348.344h8.718c.376 0 .696.303.696.688V7.94c0 .565.46 1.032 1.044 1.032.571 0 1.045-.467 1.045-1.032V1.404c0-.771.612-1.376 1.392-1.376.766 0 1.393.605 1.393 1.376v2.408l.007.07c.032.158.17.276.34.288h3.844l-.072-.07c1.531 0 2.785 1.224 2.785 2.752l.001.001v23.395C32 31.76 30.747 33 29.215 33H2.771C1.24 33-.014 31.761.001 30.248V6.867l.004-.168c.087-1.449 1.292-2.584 2.78-2.584H4.89c.376 0 .697.302.697.688v3.11c0 .564.46 1.032 1.044 1.032.57 0 1.044-.468 1.044-1.032V1.376l.007-.134C7.747.536 8.333 0 9.067 0zm19.481 12.4H3.497c-.376 0-.696.316-.683.7v16.515l.008.103c.049.335.334.586.689.599H28.59c.376 0 .696-.317.696-.689l-.042-16.555c0-.371-.32-.688-.696-.674zM9.734 24.75c.768.014 1.396.616 1.396 1.382 0 .752-.628 1.368-1.396 1.368H8.352c-.781.013-1.395-.602-1.395-1.355 0-.766.614-1.368 1.395-1.368h1.41zm6.957 0c.768.014 1.396.616 1.396 1.382 0 .752-.628 1.368-1.396 1.368h-1.382c-.782.013-1.396-.602-1.396-1.355 0-.766.614-1.368 1.396-1.368h1.41zm6.957 0c.767.014 1.395.616 1.395 1.382 0 .752-.628 1.368-1.395 1.368h-1.382c-.782.013-1.396-.602-1.396-1.355 0-.766.614-1.368 1.396-1.368h1.41zm-13.914-5.5c.768.014 1.396.616 1.396 1.382 0 .752-.628 1.368-1.396 1.368H8.352c-.781.013-1.395-.602-1.395-1.355 0-.766.614-1.368 1.395-1.368h1.41zm6.957 0c.768.014 1.396.616 1.396 1.382 0 .752-.628 1.368-1.396 1.368h-1.382c-.782.013-1.396-.602-1.396-1.355 0-.766.614-1.368 1.396-1.368h1.41zm6.957 0c.767.014 1.395.616 1.395 1.382 0 .752-.628 1.368-1.395 1.368h-1.382c-.782.013-1.396-.602-1.396-1.355 0-.766.614-1.368 1.396-1.368h1.41zm-13.914-5.5c.768.014 1.396.615 1.396 1.381 0 .752-.628 1.367-1.396 1.367l.014.002H8.352c-.781.013-1.395-.602-1.395-1.354 0-.766.614-1.367 1.395-1.367h1.41zm6.957 0c.768.014 1.396.615 1.396 1.381 0 .752-.628 1.367-1.396 1.367l.014.002h-1.396c-.782.013-1.396-.602-1.396-1.354 0-.766.614-1.367 1.396-1.367h1.41zm6.957 0c.767.014 1.395.615 1.395 1.381 0 .752-.628 1.367-1.395 1.367l.013.002h-1.395c-.782.013-1.396-.602-1.396-1.354 0-.766.614-1.367 1.396-1.367h1.41z"
        />
        <path id="l4bcx7g1uc" d="M0 0H175.304V173.25H0z" />
      </defs>
      <g>
        <g>
          <g transform="translate(-115 -856) translate(115 856)">
            <mask id="ijmiffi17b">
              <use xlinkHref="#nsresuntxa" />
            </mask>
            <use xlinkHref="#nsresuntxa" />
            <g mask="url(#ijmiffi17b)">
              <g transform="translate(-70.957 -70.125)">
                <mask id="o2763hou2d">
                  <use xlinkHref="#l4bcx7g1uc" />
                </mask>
                <use xlinkHref="#l4bcx7g1uc" />
                <path d="M-89.043 -88H264.348V261.25H-89.043z" mask="url(#o2763hou2d)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default InformacaoAgendamentoIcon
